import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import { Observable } from 'rxjs';
import { ILead } from 'src/app/leads-dashboard/types/lead';

@Injectable({
    providedIn: "root",
})
export class DbLeadsProvider {
    constructor(private aFirestore: AngularFirestore) {}

    /**
     * Fetches leads associated with a specific user for a given event.
     *
     * @param eventId - The unique identifier of the event.
     * @param userId - The unique identifier of the user.
     *
     * @returns An Observable of ILead[] representing the fetched leads.
     *
     * @example
     * ```typescript
     * const eventId = '12345';
     * const userId = '67890';
     *
     * dbLeadsProvider.fetchLeads(eventId, userId).subscribe(leads => {
     *   console.log(leads);
     * });
     * ```
     */
    fetchLeads(eventId: string, userId: string) {
        return this.aFirestore
            .collection(`events/${eventId}/users/${userId}/leads`)
            .valueChanges() as Observable<ILead[]>;
    }
}
